import Axios from "axios";
import loginTool from "../config/loginTool";
import UserInfoModal from "./UserInfoModal.vue";
import ChangePassword from "./ChangePassword.vue";
import SysMenu from "./SysMenu";
import { clearLoginAuth } from '@/config/loginAuth';
export default {
  name: "app",
  components: {
    UserInfoModal: UserInfoModal,
    ChangePassword: ChangePassword,
    SysMenu: SysMenu
  },
  data: function data() {
    return {
      sysMenuMode: '2',
      // 1 小于768 2 大于768
      showMenuDrawer: false,
      userInfostatus: false,
      changePasswordstatus: false
    };
  },
  computed: {
    user: function user() {
      return this.$store.state.user || {};
    }
  },
  methods: {
    getSysMenuMode: function getSysMenuMode() {
      if (window.innerWidth <= 768) {
        this.sysMenuMode = '1';
      } else {
        this.sysMenuMode = '2';
      }
    },
    selectMode: function selectMode(name) {
      switch (name) {
        case 'userInfo':
          {
            this.userInfostatus = true;
            break;
          }
        case 'changePassword':
          {
            this.changePasswordstatus = true;
            break;
          }
        case 'logout':
          {
            this.logout();
            break;
          }
      }
    },
    logout: function logout() {
      var _this = this;
      this.$Modal.confirm({
        title: '退出',
        content: '<p>是否确认退出登录？</p>',
        onOk: function onOk() {
          Axios.delete("users/auth/").then(function () {
            clearLoginAuth();
            _this.$router.push('/login');
          });
        },
        onCancel: function onCancel() {}
      });
    },
    // 修改个人信息后，重新获取个人信息
    onModalClose: function onModalClose(v) {
      var _this2 = this;
      if (!v) {
        return false;
      }
      Axios.get("users/current-user/").then(function (resp) {
        var _resp$data = resp.data,
          code = _resp$data.code,
          user = _resp$data.user;
        if (code === 0 && user !== null) {
          var _loginTool$getLoginIn = loginTool.getLoginInfo(user),
            authHash = _loginTool$getLoginIn.authHash,
            menuHash = _loginTool$getLoginIn.menuHash;
          _this2.$store.commit('updateLoginInfo', {
            user: user,
            authHash: authHash,
            menuHash: menuHash
          });
        }
      });
    }
  },
  created: function created() {
    var _this3 = this;
    this.getSysMenuMode();
    window.onresize = function () {
      _this3.getSysMenuMode();
    };
  }
};